import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useMemo, useState, useCallback } from 'react';
import { createUseStyles, Text, Icon, Link, Markdown, useTheme } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import { useWeb5Context } from "../../../../../lib/Web5Context";
import { getMomentFromDateBackend, isSame, isToday, getDateToUserTimezone } from "../../../../../utils/time";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'CopilotComment');
var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "contentCopy"
});
var _ref3 = /*#__PURE__*/React.createElement(Icon, {
  name: "done"
});
var _ref4 = /*#__PURE__*/React.createElement(Icon, {
  name: "infoOutlined"
});
const Comment = /*#__PURE__*/memo(_ref => {
  let {
    interactionId,
    text,
    isUser,
    isError,
    actionOnError,
    onClick,
    isWidget,
    isProgress,
    onCopy,
    creationDate
  } = _ref;
  const classes = useStyles();
  const theme = useTheme();
  const {
    t
  } = useWeb5Context();
  const [isCopied, setIsCopied] = useState(false);
  const commentProps = useMemo(() => {
    let obj = {};
    if (interactionId) {
      obj.id = interactionId;
    }
    return obj;
  }, [interactionId]);
  const handleOnCopy = useCallback(() => {
    onCopy && onCopy();
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  }, [onCopy]);
  const date = useMemo(() => {
    if (!creationDate) return '';
    const dateMoment = getMomentFromDateBackend(creationDate, 'DD/MM/YYYY HH:mm:ss', true);
    if (isToday(creationDate)) return getDateToUserTimezone({
      date: dateMoment,
      outputFormat: 'HH:mm A'
    });else if (isSame(dateMoment, 'year')) return getDateToUserTimezone({
      date: dateMoment,
      outputFormat: 'DD/MM HH:mm A'
    });else return getDateToUserTimezone({
      date: dateMoment,
      outputFormat: 'DD/MM/YYYY HH:mm A'
    });
  }, [creationDate]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classnames(classes.root, {
      'dana-chat-comment--clickable': onClick || false,
      'dana-chat-comment--copy': !isCopied && !isWidget && onCopy || false,
      'dana-chat-comment--copied': isCopied || false
    })
  }, commentProps, {
    onClick: onClick
  }), /*#__PURE__*/React.createElement("div", {
    className: "dana-chat-comment-data"
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('dana-chat-comment-text-container', {
      'dana-chat-comment-user': isUser
    })
  }, !isWidget && /*#__PURE__*/React.createElement("div", {
    className: "dana-chat-comment-actions"
  }, date && /*#__PURE__*/React.createElement(Text, {
    className: "dana-chat-comment-date",
    type: "caption",
    color: theme.colors.utility.textSecondary
  }, date), !isProgress && /*#__PURE__*/React.createElement(React.Fragment, null, onCopy && /*#__PURE__*/React.createElement("div", {
    className: "dana-chat-comment-copy__icon",
    onClick: !isCopied ? handleOnCopy : undefined
  }, !isCopied && _ref2, isCopied && _ref3))), /*#__PURE__*/React.createElement(Markdown, {
    className: classes.chatText,
    content: text ? text : '...'
  }))), isError && /*#__PURE__*/React.createElement("div", {
    className: "dana-chat-comment-error"
  }, _ref4, /*#__PURE__*/React.createElement(Text, {
    type: "body",
    color: theme.colors.utility.textSecondary
  }, t('label_dana_summary_error_not_sent')), /*#__PURE__*/React.createElement(Link, {
    variation: "primary",
    onClick: actionOnError
  }, t('action_dana_chat_error_try_again'))));
});
export default Comment;